import AuthContext from "@/context/auth";
import useDeviceInfo from "@/libs/hooks/device-info";
import { chatroomStore } from "@/libs/stores/chatroom.store";
import { fullscreenStore } from "@/libs/stores/fullscreen.store";
import { Box, Circle, Flex, useToast } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useCallback, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import FAIcon from "./FAIcon";

const MOBILE_NAVIGATION_HEIGHT = 80;
const MOBILE_NAVIGATION_Z_INDEX = 1700;

const NavigationButton = ({
  id,
  url,
  badge,
  notice,
  icon,
  iconType = "regular",
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const matchedPath = url === pathname || pathname.startsWith(url);
  return (
    <Box
      id={id}
      role="button"
      onClick={() => navigate(url)}
      color={matchedPath ? "secondary.100" : "white"}
      position="relative"
    >
      <FAIcon fontSize="1.5rem" variant={iconType} type={icon} />
      {badge && (
        <Circle
          right={-3}
          top={-3}
          position="absolute"
          bg="#EE3D52"
          size={6}
          fontSize="xs"
        >
          {badge}
        </Circle>
      )}
      {notice && (
        <Circle right={-1} top={-1} position="absolute" bg="#EE3D52" size={2}>
          {badge}
        </Circle>
      )}
    </Box>
  );
};

const MobileNavigation = () => {
  const { t } = useTranslation();

  const { chat } = chatroomStore.allChatrooms;
  const { user } = useContext(AuthContext);
  const { isMobile, isIPhone } = useDeviceInfo();
  const toast = useToast();

  const navigate = useNavigate();
  const totalUnread = chatroomStore.unreadCount;

  const unreadMessages = useMemo(() => {
    if (totalUnread === 0) return null;
    return totalUnread > 99 ? "99+" : totalUnread;
  }, [totalUnread]);

  const onCTA = useCallback(async () => {
    return navigate("/auth/register");
  }, [isMobile, navigate, toast]);

  return (
    <Box
      id="app-navigation"
      position="fixed"
      bottom={0}
      hidden={!!chat}
      width="100vw"
      display={{ base: "block", md: "none" }}
      height={`${MOBILE_NAVIGATION_HEIGHT}px`}
      zIndex={MOBILE_NAVIGATION_Z_INDEX}
      bg="primary.100"
      pb={isIPhone ? 2 : 0}
      style={{
        transform: `translateY(${fullscreenStore.hideNav ? "100%" : "0"})`,
        transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
        // opacity: fullscreenStore.hideNav ? 0 : 1,
      }}
    >
      {!user && (
        <Flex
          position="absolute"
          height="100%"
          width="100%"
          align="center"
          justify="center"
          color="white"
          fontSize="xl"
          gap={3}
          zIndex={1}
          bg="rgba(0,0,0,.8)"
          pb={isIPhone ? 2 : 0}
          onClick={onCTA}
        >
          <FAIcon type="lock" variant="regular" />
          <Box role="button" onClick={onCTA} textDecor="underline">
            {isMobile && t("navigation.register_cta")}
          </Box>
          <FAIcon type="lock" variant="regular" />
        </Flex>
      )}
      <Flex
        left={0}
        gap={2}
        display={{ base: "flex", md: "none" }}
        height="100%"
        color="white"
        align="center"
        justify="space-between"
        px={8}
      >
        <NavigationButton
          id="button__navigation_index"
          url="/videos"
          icon="film"
        />
        <NavigationButton
          id="button__navigation_explore"
          url="/explore"
          icon="home"
        />
        <NavigationButton
          id="button__navigation_chats"
          url="/chats"
          icon="comments"
          badge={unreadMessages}
        />
        {/*<NavigationButton*/}
        {/*  id="button__navigation_notifications"*/}
        {/*  url="/notifications"*/}
        {/*  icon="bell"*/}
        {/*  notice={notificationNotice}*/}
        {/*/>*/}
        <NavigationButton
          id="button__navigation_profile"
          url="/profile"
          icon="user"
        />
      </Flex>
    </Box>
  );
};
MobileNavigation.HEIGHT = MOBILE_NAVIGATION_HEIGHT;
MobileNavigation.Z_INDEX = MOBILE_NAVIGATION_Z_INDEX;
export default observer(MobileNavigation);
